/// <amd-module name="TFS/Samples/MasterDetails/LayerComponents/PullRequest/PullRequestMasterContent" />
import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { IListItemDetails, List, ListItem, ListSelection } from "VSSUI/List";
import { bindSelectionToObservable } from "VSSUI/MasterDetailsContext";
import { IPullRequest, pullRequestItemProvider } from "../../SampleData";

export const PullRequestMasterContent: React.FunctionComponent<{ initialSelectedMasterItem: IObservableValue<IPullRequest> }> = props => {
    const [selection] = React.useState(new ListSelection({ selectOnFocus: false }));

    React.useEffect(() => {
        bindSelectionToObservable(selection, pullRequestItemProvider, props.initialSelectedMasterItem);
    });

    return <List itemProvider={pullRequestItemProvider} selection={selection} renderRow={renderListRow} width="100%" />;
};

const renderListRow = (index: number, item: IPullRequest, details: IListItemDetails<IPullRequest>, key?: string): JSX.Element => {
    return (
        <ListItem className="master-example-row" key={key || "list-item" + index} index={index} details={details}>
            <div className="flex-row flex-center h-scroll-hidden" style={{ padding: "10px 0px" }}>
                <div className="flex-noshrink" style={{ width: "32px" }} />
                <div className="flex-column flex-shrink" style={{ minWidth: 0 }}>
                    <div className="primary-text text-ellipsis">{item.title}</div>
                    <div className="secondary-text">{item.author}</div>
                </div>
            </div>
        </ListItem>
    );
};
